import React, { useRef, useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth, db } from "../../../firebase";
import { reauthenticateWithPopup, GoogleAuthProvider, reauthenticateWithCredential, EmailAuthProvider, updateProfile, sendPasswordResetEmail, deleteUser, signOut, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, updateDoc, deleteDoc, writeBatch, collection, getDocs } from "firebase/firestore";
import { getStorage, ref, listAll, deleteObject } from "firebase/storage";
import MyPageMenu from './MyPageMenu';
import Loading from "../../Loading";
import SEO from '../../SEO';
import Popup from "../../mobile/Popup";
import { DeleteMusicard } from '../LogandUtils';

import styleClasses from '../css/mobile/MyPage.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

function MyPage() {
  const navigate = useNavigate();

  const emailRef      = useRef();
  const nameRef       = useRef();
  // const isSubmitting1 = useRef(false);  // 이메일 변경
  const isSubmitting2 = useRef(false);  // 이름 변경
  const isSubmitting3 = useRef(false);  // 비밀번호 재설정
  const isSubmitting4 = useRef(false);  // 로그아웃
  const isSubmitting5 = useRef(false);  // 회원탈퇴

  const [openMenu, setOpenMenu]               = useState(true);
  const [isLoading, setIsLoading]             = useState(true);
  const [email, setEmail]                     = useState("");
  // const [isEditingEmail, setIsEditingEmail]   = useState(false);
  const isEditingEmail = false;
  const [newEmail, setNewEmail]               = useState("");
  const [fieldDisabled, setFieldDisabled]     = useState(false);
  const [emailError, setEmailError]           = useState('');
  const [emailErrorText, setEmailErrorText]   = useState('');
  const [name, setName]                       = useState("");
  const [newName, setNewName]                 = useState('');
  const [nameError, setNameError]             = useState('');
  const [nameErrorText, setNameErrorText]     = useState('');
  const [isEditingName, setIsEditingName]     = useState(false);

  const [myMusicards, setMyMusicards]           = useState([]);
  const [selectedMusicard, setSelectedMusicard] = useState('');

  // const [buttonLoading1, setButtonLoading1]   = useState(false);
  const [buttonLoading2, setButtonLoading2]   = useState(false);
  const [buttonLoading3, setButtonLoading3]   = useState(false);
  const [buttonLoading4, setButtonLoading4]   = useState(false);
  const [buttonLoading5, setButtonLoading5]   = useState(false);
  const [openPopup, setOpenPopup]             = useState(false);
  const [popupTitle, setPopupTitle]           = useState('');
  const [popupFunction, setPopupFunction]     = useState('');
  const [popupButtonText, setPopupButtonText] = useState('');

  // CTA 화면 노출 여부 (뮤지카드가 없을 때 뮤지카드 생성을 유도하는 CTA)
  const [showCTAScreen, setShowCTAScreen] = useState(false);
  // 음원 발매 경력: 'released' (있음) 또는 'unreleased' (없음)
  const [music, setMusic] = useState('released');
  // 팀활동 여부: 'solo' (솔로) 또는 'team' (팀)
  const [artistType, setArtistType] = useState('solo');

  // 🔹 변경 버튼 클릭 시 포커스
  useEffect(() => { if (isEditingEmail) { emailRef.current.focus(); } }, [isEditingEmail]);
  useEffect(() => { if (isEditingName)  { nameRef.current.focus();  } }, [isEditingName]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser && currentUser.emailVerified) {
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
  
        if (userSnap.exists()) {
          const userData = userSnap.data();
          // setUser(currentUser);
          setEmail(currentUser.email);
          setNewEmail(currentUser.email);
          setName(userData.name);
          setNewName(userData.name);
          if (userData.type) {
            if (userData.type === 'google') {
              setFieldDisabled(true);
            }
          }

          let musicards     = [];
          const getMusicards = userData.musicard ? Object.entries(userData.musicard) : [];
          let count = 0;
          getMusicards.forEach(([id, value]) => {
            musicards.push({ id, value });
            if (count < 1) {
              setSelectedMusicard(value);
              count++;
            }
          });
          
          setMyMusicards(musicards);

          // 뮤지카드가 하나도 없으면 CTA 화면을 노출
          if (musicards.length === 0) {
            setShowCTAScreen(true);
            //GA 세팅
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "mzc_generate_start"
            });
          } else {
            setShowCTAScreen(false);
          }

          setIsLoading(false);
        } else {
          // 유저 ID가 존재하는데 데이터가 없는 경우 (구글 계정 가입 진행 중 - 개인정보보호 동의 전)
          navigate(`/google-consent?uid=${currentUser.uid}&email=${currentUser.email}&name=${currentUser.displayName}`);
        }
      } else {
        navigate("/login"); // 로그아웃되면 로그인 페이지로 이동
      }
    });
  
    return () => unsubscribe(); // 🔹 컴포넌트 언마운트 시 구독 해제
  }, [navigate]);

  // Skip 클릭 시 CTA 화면 숨김 (기존 마이페이지 콘텐츠를 보여줌)
  const handleSkipCTA = () => {
    setShowCTAScreen(false);
  };

  // 🔹 메뉴 열기
  const toogleMenu = useCallback(
    (event) => {
      const menuIcon = event.target.closest(`.${styleClasses.menuIcon}`);
      const menuBox = event.target.closest(`.${styleClasses.leftContent}`);

      if (openMenu) {
        if (!menuBox) setOpenMenu(false);
      } else {
        if (menuIcon || menuBox) setOpenMenu(true);
      }
    },
    [openMenu, setOpenMenu]
  );

  // 🔹 메뉴 열기 (스크린 전체 이벤트 추가)
  useEffect(() => {
    document.body.addEventListener("click", toogleMenu);

    return () => {
      document.body.removeEventListener("click", toogleMenu);
    };
  }, [toogleMenu]);

  // 🔹 로그아웃 처리
  const handleLogout = async () => {
    try {
      if (isSubmitting4.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting4.current = true;      // 버튼 비활성화
      setButtonLoading4(true);           // 버튼 로딩 표시

      await signOut(auth);
      isSubmitting4.current = false;   // 버튼 활성화
      setButtonLoading4(false);        // 버튼 로딩 숨김
      navigate("/login");              // 로그아웃 후 로그인 페이지로 이동
    } catch (error) {
      isSubmitting4.current = false;   // 버튼 활성화
      setButtonLoading4(false);        // 버튼 로딩 숨김
      setPopupTitle(error.message);
      setOpenPopup(true);
    }
  };

  // 🔹 에러 메세지 초기화
  const resetError = (event) => {
    if (event.target.id === 'email') {
      setEmailError('');
      setEmailErrorText('');
    } else if (event.target.id === 'name') {
      setNameError('');
      setNameErrorText('');
    }
  };

  /*// 🔹 이메일 유효성 검사
  const validateEmail = (value) => {
    if (value === '') {
      setEmailErrorText('이메일 주소를 입력하세요.');
      return false;
    } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(value) === false) {
        setEmailErrorText('올바른 이메일 주소를 입력하세요.');
      }
      return emailRegex.test(value);
    }
  };*/

   /*// 🔹 이메일 변경 처리
  const handleEmailChange = async () => {
    if (validateEmail(newEmail) === false) {
      setEmailError('error');
      emailRef.current.focus();
      return;
    }

    try {
      if (isSubmitting1.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting1.current = true;      // 버튼 비활성화
      setButtonLoading1(true);           // 버튼 로딩 표시
      
      await updateEmail(auth.currentUser, newEmail);
      const userRef = doc(db, "users", auth.currentUser.uid);
      await updateDoc(userRef, { email: newEmail });

      setEmail(newEmail);
      setIsEditingEmail(false);

      isSubmitting1.current = false;   // 버튼 활성화
      setButtonLoading1(false);        // 버튼 로딩 숨김

      setOpenPopup(true);
      setPopupTitle('이메일이 성공적으로 변경되었습니다.');
      setPopupButtonText('');
      setPopupFunction('');
    } catch (error) {
      isSubmitting1.current = false;   // 버튼 활성화
      setButtonLoading1(false);        // 버튼 로딩 숨김

      setOpenPopup(true);
      setPopupTitle("이메일 변경 실패: " + error.message);
      setPopupFunction(() => () => navigate('/'));
      setPopupButtonText('메인으로 이동');
    }
  };*/

  // 🔹 이름 변경 처리
  const handleNameChange = async () => {
    if (newName === '') {
      setNameErrorText('이름을 입력하세요.');
      setNameError('error');
      nameRef.current.focus();
      return;
    }

    try {
      if (isSubmitting2.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting2.current = true;      // 버튼 비활성화
      setButtonLoading2(true);           // 버튼 로딩 표시
      
      await updateProfile(auth.currentUser, { displayName: newName });
      const userRef = doc(db, "users", auth.currentUser.uid);
      await updateDoc(userRef, { 'name': newName });

      setName(newName);
      setIsEditingName(false);

      isSubmitting2.current = false;   // 버튼 활성화
      setButtonLoading2(false);        // 버튼 로딩 숨김

      setOpenPopup(true);
      setPopupTitle('이름이 성공적으로 변경되었습니다.');
      setPopupButtonText('');
      setPopupFunction('');
    } catch (error) {
      isSubmitting2.current = false;   // 버튼 활성화
      setButtonLoading2(false);        // 버튼 로딩 숨김

      setOpenPopup(true);
      setPopupTitle("이름 변경 실패: " + error.message);
      setPopupFunction(() => () => navigate('/'));
      setPopupButtonText('메인으로 이동');
    }
  };

  // 🔹 비밀번호 재설정 이메일 전송
  const handlePasswordReset = async () => {
    try {
      if (isSubmitting3.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting3.current = true;      // 버튼 비활성화
      setButtonLoading3(true);           // 버튼 로딩 표시

      await sendPasswordResetEmail(auth, email);
      
      isSubmitting3.current = false;   // 버튼 활성화
      setButtonLoading3(false);        // 버튼 로딩 숨김

      setOpenPopup(true);
      setPopupTitle('비밀번호 재설정 이메일이 전송되었습니다.');
      setPopupButtonText('');
      setPopupFunction('');
    } catch (error) {
      isSubmitting3.current = false;   // 버튼 활성화
      setButtonLoading3(false);        // 버튼 로딩 숨김

      setOpenPopup(true);
      setPopupTitle("비밀번호 재설정 실패: " + error.message);
      setPopupFunction(() => () => navigate('/'));
      setPopupButtonText('메인으로 이동');
    }
  };

  // 🔹 회원 탈퇴 팝업
  const opendDeleteAccountPopup = () => {
    setOpenPopup(true);
    setPopupTitle('정말로 회원탈퇴 하시겠습니까?');
    setPopupButtonText('회원탈퇴');
    setPopupFunction(() => handleDeleteAccount );
  }
  
  // 🔹 회원 탈퇴 처리
  const handleDeleteAccount = async () => {
    try {
      if (isSubmitting5.current) return;  // 실행 중일 경우 중복 클릭 방지
      isSubmitting5.current = true;       // 버튼 비활성화
      setButtonLoading5(true);            // 버튼 로딩 표시
  
      const user = auth.currentUser;
      if (!user) throw new Error("사용자가 로그인되어 있지 않습니다.");
  
      // 재인증: 사용자가 구글 계정으로 로그인했는지 확인
      const isGoogleUser = user.providerData.some(
        (provider) => provider.providerId === "google.com"
      );

      if (isGoogleUser) {
        // 구글 사용자: 팝업을 통한 재인증
        await reauthenticateWithPopup(user, new GoogleAuthProvider());
      } else {
        // 이메일/비밀번호 사용자: 비밀번호 재입력 후 재인증
        const password = prompt("회원탈퇴를 위해 비밀번호를 다시 입력하세요.");
        if (!password) {
          throw new Error("비밀번호를 입력해야 합니다.");
        }
        const credential = EmailAuthProvider.credential(user.email, password);
        await reauthenticateWithCredential(user, credential);
      }
  
      // ──────────────────────────────
      // Step 1: 뮤지카드 삭제
      // /users/[UID] 문서에서 musicard 필드를 읽어 뮤지카드 ID들을 가져옴
      const userDocRef = doc(db, "users", user.uid);
      const userDocSnap = await getDoc(userDocRef);
      let musicardIds = [];
      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();
        if (userData.musicard) {
          // 예: { team_01: "Sihumyong", solo_01: "dev_apod" } → ["Sihumyong", "dev_apod"]
          musicardIds = Object.values(userData.musicard);
        }
      }
      // 각 뮤지카드 삭제 처리
      for (const musicardId of musicardIds) {
        await DeleteMusicard({ id: musicardId });
      }
      // ──────────────────────────────
      // Step 2: users_data 하위 컬렉션 및 문서 삭제
      async function deleteCollection(path, subcollections = []) {
        const colRef = collection(db, path);
        const snapshot = await getDocs(colRef);
        for (const docSnap of snapshot.docs) {
          // 지정된 하위 서브컬렉션이 있으면 먼저 삭제
          for (const subCollName of subcollections) {
            const subCollPath = `${path}/${docSnap.id}/${subCollName}`;
            const subSnapshot = await getDocs(collection(db, subCollPath));
            if (!subSnapshot.empty) {
              const batch = writeBatch(db);
              subSnapshot.forEach(subDoc => {
                batch.delete(subDoc.ref);
              });
              await batch.commit();
            }
          }
          // 상위 문서 삭제
          await deleteDoc(doc(db, path, docSnap.id));
        }
      }
      
      const userDataCollections = [
        { name: "activity", subcollections: [] },
        { name: "contact", subcollections: [] },
        { name: "members", subcollections: [] },
        { name: "positions", subcollections: ["skills"] },
        { name: "released", subcollections: ["tracks"] },
        { name: "unreleased", subcollections: ["tracks"] }
      ];
      
      for (const coll of userDataCollections) {
        const path = `users_data/${user.uid}/${coll.name}`;
        await deleteCollection(path, coll.subcollections);
      }
      // 삭제 후, /users_data/[UID] 문서 자체도 삭제
      const userDataDocRef = doc(db, "users_data", user.uid);
      await deleteDoc(userDataDocRef);
      // ──────────────────────────────
      // Step 3: Firebase Storage 내 /users/[UID] 폴더 삭제
      // Storage 내의 모든 파일(및 하위 폴더 파일들)을 재귀적으로 삭제하는 헬퍼 함수
      async function deleteFolderFiles(folderRef) {
        const listResult = await listAll(folderRef);
        // 폴더 내 모든 파일 삭제
        for (const itemRef of listResult.items) {
          try {
            await deleteObject(itemRef);
            console.log("삭제됨:", itemRef.fullPath);
          } catch (error) {
            console.error("Storage 파일 삭제 오류:", error);
          }
        }
        // 하위 폴더에 대해 재귀 호출
        for (const prefixRef of listResult.prefixes) {
          await deleteFolderFiles(prefixRef);
        }
      }
      const storage = getStorage();
      const userFolderRef = ref(storage, `users/${user.uid}`);
      await deleteFolderFiles(userFolderRef);
      // ──────────────────────────────
      // Step 4: /users/[UID] 문서 삭제
      await deleteDoc(userDocRef);
      // ──────────────────────────────
      // Step 5: Firebase Authentication 계정 삭제
      await deleteUser(user);
  
      isSubmitting5.current = false;
      setButtonLoading5(false);
      
      setOpenPopup(true);
      setPopupTitle('회원탈퇴가 완료되었습니다.');
      setPopupButtonText('메인으로 이동');
      setPopupFunction(() => () => navigate('/'));
  
      setTimeout(() => {
        navigate("/"); // 홈으로 리디렉션
      }, 5000);
    } catch (error) {
      isSubmitting5.current = false;
      setButtonLoading5(false);
      setOpenPopup(true);
      setPopupTitle("회원탈퇴 실패: " + error.message);
      setPopupFunction(() => () => navigate('/'));
      setPopupButtonText('메인으로 이동');
    }
  };

  // 🔹 포트폴리오 미리보기 페이지 이동
  const moveToPortfolio = () => {
    navigate('/my-page/portfolio', { state: { musicardID: selectedMusicard } });
  }

  //const host = window.location.host;
  //const production = host.includes('localhost') || host.includes(':3000') ? false : true;

  return (
    <>
      <SEO title='마이 페이지' />
      <div className={ styleClasses.myPageMobile }>
        <div className={styleClasses.inner}>
          {
            (!isLoading && myMusicards.length === 0 && showCTAScreen)
            ?
            (
              <div className={ styleClasses.cta }>
                <div className={ styleClasses.inner }>
                  <div className={ styleClasses.title }>
                    <h1>아직 뮤지카드가 없어요.</h1>
                  </div>
                  <div className={styleClasses.description}>
                    <h2 className={ styleClasses.mainTitle }>뮤지카드 생성</h2>
                    <h3 className={ styleClasses.subtitle }>간단하지만 확실한, 내 음악 활동을 보여주는 방법. <br />지금, 뮤지카드를 만들어보세요.</h3>
                  </div>
                  <div className="commonForm">
                    {/* 음원 발매 경력 라디오 버튼 */}
                    <div className="formRow fullWidth">
                      <div className="labelBox">
                        <label>음원 발매 여부 선택</label>
                      </div>
                      <div className="fieldBox checkBox">
                        <div className="eachBox">
                          <input
                            type="radio"
                            name="music"
                            id="released"
                            value="released"
                            checked={music === "released"}
                            onChange={(e) => setMusic(e.target.value)}
                          />
                          <label htmlFor="released">
                            발매 이력 있음
                            <div className="commonIcon mobile toolTip">
                              <i className="questionBlack w16"></i>
                              <div className="toolTipText bottom">
                                <p>유튜브 뮤직에서 <br />검색이 가능한 경우 선택해 주세요.</p>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                      <divl className="fieldBox checkBox">
                        <div className="eachBox">
                          <input
                            type="radio"
                            name="music"
                            id="unreleased"
                            value="unreleased"
                            checked={music === "unreleased"}
                            onChange={(e) => setMusic(e.target.value)}
                            />
                          <label htmlFor="unreleased">
                            발매 이력 없음
                            <div className="commonIcon mobile toolTip">
                              <i className="questionBlack w16"></i>
                              <div className="toolTipText bottom">
                                <p>정식 유통은 하지 않았지만, <br />사운드 클라우드에 음원이 <br />업로드 되어 있는 경우 선택해주세요.</p>
                              </div>
                            </div>
                          </label>
                        </div>
                      </divl>
                    </div>
                    {/* 팀/솔로 라디오 버튼 */}
                    <div className="formRow fullWidth">
                      <div className="labelBox">
                        <label>활동 형태</label>
                      </div>
                      <div className="fieldBox checkBox">
                        <div className="eachBox">
                          <input
                            type="radio"
                            name="artistType"
                            id="solo"
                            value="solo"
                            checked={artistType === "solo"}
                            onChange={(e) => setArtistType(e.target.value)}
                            />
                          <label htmlFor="solo">솔로</label>
                        </div>
                      </div>
                      <div className="fieldBox checkBox">
                        <div className="eachBox">
                          <input
                            type="radio"
                            name="artistType"
                            id="team"
                            value="team"
                            checked={artistType === "team"}
                            onChange={(e) => setArtistType(e.target.value)}
                          />
                          <label htmlFor="team">팀 혹은 밴드</label>
                        </div>
                      </div>
                    </div>
                    {/* CTA 버튼 및 Skip 텍스트 */}
                    <div className="commonButton fullWidth">
                      <div className="commonButton">
                        <Link
                          to={`/my-page/musicard/create?music=${music}&type=${artistType}`}
                          className="black"
                        >
                          1분만에 뮤지카드 만들기
                        </Link>
                        <button onClick={handleSkipCTA} className={styleClasses.skipButton}>
                          Skip
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
            :
            (
              <>
                <div className={styleClasses.title}>
                  <h1>My Page</h1>
                  <button className={ styleClasses.menuIcon }>
                    <div className="commonIcon mobile">
                      <i className={`${ openMenu ? 'upWhite' : 'downWhite' } w24`}></i>
                    </div>
                  </button>
                </div>
                <div className={styleClasses.editContent}>
                  {/* 왼쪽 메뉴 */}
                  <div className={`${ styleClasses.leftContent } ${ openMenu ? styleClasses.open : '' }`}>
                    <MyPageMenu currentPage='my-page' />
                  </div>

                  {/* 오른쪽 마이페이지 콘텐츠 */}
                  <div className={styleClasses.rightContent}>
                    <div className={styleClasses.content}>
                      <h2 className={ styleClasses.subtitle }>My Account</h2>
                      {
                        isLoading
                        ?
                        (
                          <Loading />
                        )
                        :
                        (
                          <div className="commonForm">
                            {/* 🔹 이메일 표시 & 변경 */}
                            <div className={`formRow ${ styleClasses.customForm }`}>
                              <div className="labelBox">
                                <label htmlFor="email">이메일</label>
                              </div>
                              <div className={`fieldBox ${ emailError } ${ styleClasses.customFieldBox }`}>
                                <input type="email" id="email" name="email" placeholder="새 이메일 주소" value={ newEmail } ref={ emailRef } onChange={ (e) => { setNewEmail(e.target.value); resetError(e); }}
                                  style={ isEditingEmail ? { display: 'flex' } : { display: 'none' } }
                                />
                                <div className="fieldError">
                                  <p>{ emailErrorText }</p>
                                </div>
                                <p className={ styleClasses.displayValue } style={ isEditingEmail ? { display: 'none' } : { display: 'flex' } }>{ email }</p>
                              </div>
                              {/*
                                fieldDisabled === false
                                &&
                                <div className={`buttonBox ${ styleClasses.customButtonBox }`}>
                                  {
                                    isEditingEmail
                                    ?
                                    <>
                                      <div className="commonButton">
                                        <button className="black" onClick={ handleEmailChange }>
                                          변경
                                          <div className={`buttonLoading ${ buttonLoading1 && 'active' }`}>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                          </div>
                                        </button>
                                      </div>
                                      <div className="commonButton">
                                        <button onClick={ () => { setIsEditingEmail(false); setNewEmail(email); setEmailError(''); setEmailErrorText(''); } }>취소</button>
                                      </div>
                                    </>
                                    :
                                    <div className="commonButton">
                                      <button onClick={ () => { setIsEditingEmail(true) } }>이메일 수정</button>
                                    </div>
                                  }
                                </div>
                              */}
                            </div>
                            {/* 🔹 이름 수정 가능 */}
                            <div className={`formRow ${ styleClasses.customForm }`}>
                              <div className="labelBox">
                                <label htmlFor="name">이름</label>
                              </div>
                              {
                                isEditingName
                                ?
                                (
                                  <>
                                    <div className={`fieldBox ${ nameError } ${ styleClasses.customFieldBox }`}>
                                      <input type="text" id="name" name="name" value={ newName } placeholder="이름" ref={ nameRef } onChange={(e) => { setNewName(e.target.value); resetError(e); } } />
                                      <div className="fieldError">
                                        <p>{ nameErrorText }</p>
                                      </div>
                                    </div>
                                    {
                                      fieldDisabled === false
                                      &&
                                      <div className={`buttonBox ${ styleClasses.customButtonBox }`}>
                                        <div className="commonButton">
                                          <button className="black" onClick={handleNameChange}>
                                            변경
                                            <div className={`buttonLoading ${ buttonLoading2 && 'active' }`}>
                                              <div></div>
                                              <div></div>
                                              <div></div>
                                            </div>
                                          </button>
                                        </div>
                                        <div className="commonButton">
                                          <button onClick={ () => { setIsEditingName(false); setNewName(name); setNameError(''); setNameErrorText(''); } }>취소</button>
                                        </div>
                                      </div>
                                    }
                                  </>
                                )
                                :
                                (
                                  <>
                                    <div className={`fieldBox ${ styleClasses.customFieldBox }`}>
                                      <p className={ styleClasses.displayValue }>{ name }</p>
                                    </div>
                                    {
                                      fieldDisabled === false
                                      &&
                                      <div className={`buttonBox ${ styleClasses.customButtonBox }`}>
                                        <div className="commonButton">
                                          <button onClick={ () => setIsEditingName(true) }>이름 수정</button>
                                        </div>
                                      </div>
                                    }
                                  </>
                                )
                              }
                              <div className="commonButton fullWidth">
                                {
                                  fieldDisabled === false
                                  &&
                                  // 🔹 비밀번호 재설정
                                  <button onClick={ handlePasswordReset }>
                                    비밀번호 재설정
                                    <div className={`buttonLoading black ${ buttonLoading3 && 'active' }`}>
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                    </div>
                                  </button>
                                }
                                {/* 🔹 로그아웃 버튼 */}
                                <button className="black" onClick={ handleLogout }>
                                  로그아웃
                                  <div className={`buttonLoading ${ buttonLoading4 && 'active' }`}>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                  </div>
                                </button>
                                {/* 🔹 회원 탈퇴 */}
                                <button className="secondary" onClick={ opendDeleteAccountPopup }>
                                  회원탈퇴
                                </button>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    {
                      (
                        isLoading 
                        ?
                        <Loading />
                        :
                        <div className={ styleClasses.content }>
                          <h2 className={ styleClasses.subtitle }>My Portfolio</h2>
                          <p style={{ fontSize: '13px' }}>만들어 둔 뮤지카드를 기반으로,<br />클릭 한 번에 포트폴리오를 만들 수 있습니다.<br />내 음악 경력을 정리한 포트폴리오를 다운받고 공유 해보세요!</p>
                          <div className={ styleClasses.fieldWithButton }>
                            {
                              myMusicards.length
                              ?
                              (
                                <>
                                  <div className="commonForm">
                                    <div className="formRow fullWidth">
                                      <div className="labelBox">
                                        <label htmlFor="musicard">내 뮤지카드 선택</label>
                                        <div className={`commonIcon toolTip ${ styleClasses.topButtonToolTip }`}>
                                          <i className="questionBlack w20"></i>
                                          <div className="toolTipText bottom">
                                          <p>뮤지카드는 'My Musicard'에서 만들 수 있어요!</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="fieldBox">
                                        <select id="musicard" value={ selectedMusicard } onChange={ (e) => setSelectedMusicard(e.target.value) }> 
                                          {
                                            myMusicards.map((musicard) => (
                                              <option key={ musicard.id } value={ musicard.value }>{ musicard.value }</option>
                                            ))
                                          }
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="commonButton fullWidth">
                                    <button onClick={ moveToPortfolio }>지금 만들기</button>
                                  </div>
                                </>
                              )
                              :
                              <p>뮤지카드를 추가해주세요.</p>
                            }
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              </>
            )
          }
        </div>
      </div>
      <Popup open={ openPopup } setOpenPopup={ setOpenPopup } title={ popupTitle } text='' buttonText={ popupButtonText } buttonFunction={ popupFunction } buttonLoading={ buttonLoading5 } />
    </>
  );
}

export default MyPage;
